import { getCustomEmoji } from '@/atoms/emojis'
import { TMailboxRelay } from '@/types'
import * as kinds from '@nostr/tools/kinds'
import { now } from './utils'
import { EventTemplate } from '@nostr/tools/core'

export function createRelayListDraftEvent(mailboxRelays: TMailboxRelay[]): EventTemplate {
  return {
    kind: kinds.RelayList,
    content: '',
    tags: mailboxRelays.map(({ url, scope }) =>
      scope !== 'both' ? ['r', url, scope] : ['r', url]
    ),
    created_at: now()
  }
}

export function transformCustomEmojisInContent(content: string) {
  const emojiTags: string[][] = []
  let processedContent = content
  const matches = content.match(/:[a-zA-Z0-9]+:/g)

  const emojiIdSet = new Set<string>()
  for (const m of matches ?? []) {
    if (emojiIdSet.has(m)) continue
    emojiIdSet.add(m)

    const emoji = getCustomEmoji(m.slice(1, -1))
    if (emoji) {
      emojiTags.push(['emoji', emoji.shortcode, emoji.url])
      processedContent = processedContent.replace(new RegExp(m, 'g'), `:${emoji.shortcode}:`)
    }
  }

  return {
    emojiTags,
    content: processedContent
  }
}

export function trimTagEnd(tag: string[]) {
  let endIndex = tag.length - 1
  while (endIndex >= 0 && tag[endIndex] === '') {
    endIndex--
  }

  return tag.slice(0, endIndex + 1)
}
